module.exports = __webpack_public_path__ + "static/media/imagenet7.e8009a7f.png";